<template>
<div>
    <v-row>
            <v-col cols="12" sm="12" >
                    <v-container fluid>
                        <pdf v-for="i in numPages"
                            :key="i"
                            :src="src"
                            :page="i"
                            style="display: inline-block; width: 100%">
                        </pdf>
                    </v-container>
            </v-col>
    </v-row>
</div>
</template>
<script>
import pdf from 'vue-pdf'

// var loadingTask = pdf.createLoadingTask(window.config.appUrl + '/pdf/guide.pdf');

export default {
    name: "help-view",
    components: { pdf },
    data() {
		return {
            src: pdf.createLoadingTask(window.config.appUrl + '/pdf/guide.pdf'),
			numPages: undefined,
		}
    },
    mounted() {
		this.src.then(pdf => {
			this.numPages = pdf.numPages;
		});
	}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/overview/help.vue